class PolicyContactSummaryCtrl {
    constructor($stateParams) {
        this.policyNumber = $stateParams.policyNumber;
        this.totalAccountContacts = null;
        this.pageSize = 5;
    }
}

PolicyContactSummaryCtrl.$inject = ['$stateParams'];

export default PolicyContactSummaryCtrl;